// Login Actions
export const AUTH_REQUEST = 'AUTH_REQUEST'
export const AUTH_LOGOUT = 'login/AUTH_REQUEST'

// Login Mutations
export const MUTATE_AUTH_REQUEST = 'login/MUTATE_AUTH_REQUEST'
export const MUTATE_AUTH_SUCCESS = 'login/MUTATE_AUTH_LOGOUT'
export const MUTATE_AUTH_LOGOUT = 'login/MUTATE_AUTH_LOGOUT'
export const MUTATE_AUTH_ERROR = 'login/MUTATE_AUTH_ERROR'
export const SET_IP_DETAILS = 'login/SET_IP_DETAILS'
export const SET_COPYRIGHT_INFO = 'login/SET_COPYRIGHT_INFO'
export const MUTATE_CLEAR_STORE = "login/MUTATE_CLEAR_STORE"